import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useT } from '../lib/i18n';
import { Button } from '../components/ui/button';
import { MessageSquare, Plus, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { NewChatLauncher } from '../components/NewChatLauncher';

export default function ChatList() {
    const { t, lang } = useT();
    const navigate = useNavigate();
    const [sessions, setSessions] = useState([]);
    const [launcherOpen, setLauncherOpen] = useState(false);

    const load = () => api.get('/chat/sessions').then(r => setSessions(r.data));
    useEffect(() => { load(); }, []);

    const del = async (id) => {
        if (!window.confirm(t('chats.delete.confirm'))) return;
        await api.delete(`/chat/sessions/${id}`);
        toast.success(t('chats.delete.success'));
        load();
    };

    return (
        <div className="max-w-4xl mx-auto px-6 py-10 pb-24" data-testid="chats-page">
            <div className="flex items-center justify-between">
                <h1 className="font-display text-3xl font-bold tracking-tight">{t('chats.title')}</h1>
                <Button onClick={() => setLauncherOpen(true)} className="rounded-full bg-sage hover:bg-sage-dark text-bone" data-testid="new-chat-btn">
                    <Plus className="w-4 h-4 mr-2"/> {t('chats.new')}
                </Button>
            </div>
            <div className="mt-8 space-y-2">
                {sessions.length === 0 && (
                    <div className="text-center py-16 border border-dashed border-sand rounded-2xl">
                        <MessageSquare className="w-8 h-8 mx-auto text-inkSoft"/>
                        <p className="mt-3 text-inkSoft">{t('chats.empty')}</p>
                        <Button onClick={() => setLauncherOpen(true)} className="mt-4 rounded-full bg-sage hover:bg-sage-dark text-bone" data-testid="empty-new-chat">
                            {t('chats.empty.cta')}
                        </Button>
                    </div>
                )}
                {sessions.map(s => (
                    <div key={s.session_id} className="flex items-center justify-between p-4 rounded-xl border border-sand bg-white hover:border-sage/40 transition-colors" data-testid={`chat-item-${s.session_id}`}>
                        <button className="flex-1 text-left" onClick={() => navigate(`/app/samtale/${s.session_id}`)}>
                            <p className="font-medium text-ink">{s.title}</p>
                            <p className="text-xs text-inkSoft">{new Date(s.updated_at).toLocaleString(lang === 'en' ? 'en-US' : 'nb-NO')}</p>
                            {s.summary && <p className="text-sm text-inkSoft mt-1 line-clamp-1">{s.summary}</p>}
                        </button>
                        <button onClick={() => del(s.session_id)} className="ml-3 p-2 text-inkSoft hover:text-crisis" data-testid={`delete-${s.session_id}`}>
                            <Trash2 className="w-4 h-4"/>
                        </button>
                    </div>
                ))}
            </div>
            <NewChatLauncher open={launcherOpen} onOpenChange={setLauncherOpen} />
        </div>
    );
}
